import ReactPlayerLoader from "@brightcove/react-player-loader";
import {
  BC_PLAYER_ID,
  BC_PLAYER_ID_SMALL_WIDGET,
  BH_BC_ACCOUNT_ID,
} from "@helper/getEnvVariables";
import type { BrightcovePlayer } from "@typings/Brightcove.d";
import cx from "classnames";
import { ReactElement, RefObject } from "react";

import styles from "./BrightcoveVideo.module.css";
import useBrightcoveMedia from "./hooks/useBrightcoveMedia";

type BrightcoveVideoProps = {
  videoId: string;
  forwardedRef?: RefObject<HTMLDivElement | null>;
  smallWidget?: boolean;
  onEnded?: () => void;
  nextPlaylist?: () => void;
  playerStyle?: string;
  playerId?: string;
  disableFullscreen?: boolean;
  pageRefValue?: string;
  onPlayerReady?: (player: BrightcovePlayer) => void;
  playlistId?: string;
  syncMuteAcrossPlayers?: boolean;
};

export function BrightcoveVideo({
  videoId,
  forwardedRef,
  smallWidget,
  onEnded,
  nextPlaylist,
  playerStyle,
  playerId,
  disableFullscreen,
  pageRefValue,
  onPlayerReady,
  playlistId,
  syncMuteAcrossPlayers = true,
}: BrightcoveVideoProps): ReactElement {
  const { playerRef, handleSuccess } = useBrightcoveMedia({
    onEnded,
    nextPlaylist,
    disableFullscreen,
    pageRefValue,
    onPlayerReady,
    syncMuteAcrossPlayers,
  });

  playerId =
    playerId || (smallWidget ? BC_PLAYER_ID_SMALL_WIDGET : BC_PLAYER_ID);

  return (
    <>
      {BH_BC_ACCOUNT_ID && (
        <div
          key={videoId}
          data-testid={videoId}
          className={cx(styles.brightcove, playerStyle)}
          ref={forwardedRef}
        >
          <ReactPlayerLoader
            style={{ gridColumn: 1, gridRow: 1 }}
            accountId={BH_BC_ACCOUNT_ID}
            playerId={playerId}
            {...(playlistId ? { playlistId } : { videoId })}
            videoRef={playerRef}
            onSuccess={handleSuccess}
          />
        </div>
      )}
    </>
  );
}
